'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'face-surprise';
var width = 512;
var height = 512;
var aliases = [128558,"surprise"];
var unicode = 'f5c2';
var svgPathData = ['M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm176.4-48a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM328 352a72 72 0 1 1 -144 0 72 72 0 1 1 144 0zm24.4-144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM200 352a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56 72a72 72 0 1 1 0-144 72 72 0 1 1 0 144z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceSurprise = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;